<template>
  <div>
    <ts-card-wrapper class="ts-space-y-2">
      <div class="ts-w-full ts-justify-between ts-flex">
        <div>
          <h1 class="section-divider-underline">
            {{ $t('wholesaleReceipt.invoice') }}
          </h1>
        </div>
        <!-- <div class="ts-justify-end">
          <ts-input
            v-tooltip="$t('wholesaleReceipt.search')"
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
        </div> -->
      </div>
      <div style="max-height: 70vh; height: 70vh">
        <a-table
          :scroll="{ x: 'max-content', y: 555 }"
          size="small"
          :pagination="false"
          :columns="columns"
          :row-key="payment_list => payment_list.stock_out_id"
          :data-source="model.payment_list"
          :row-selection="{ onChange: checkItem }"
          :loading="loading"
        >
          <template slot="amount_due" slot-scope="record">
            {{ displayCurrency(record) }}
          </template>
          <template slot="amount_due_paid" slot-scope="record">
            {{ displayCurrencyAmountDuePaid(record) }}
          </template>
          <template slot="amount_paid" slot-scope="record">
            <div class="ts-text-right ts-pr-3">
              {{ record ? displayCurrency(record) : '$ 0.00' }}
            </div>
          </template>
          <template slot="footer" slot-scope="record">
            <div class="ts-flex ts-justify-between ts--mx-1">
              <div>Total: {{ record.length }}</div>
              <div class="ts-flex ts-justify-items-end">
                <div
                  class="ts-text-right"
                  style="width: 130px;padding-right: 8px;"
                >
                  {{ totalInvoiceAmount(record) }}
                </div>
                <div
                  class="ts-text-right"
                  style="width: 114px;padding-right: 8px;"
                >
                  {{ totalAmountDue(record) }}
                </div>
                <div class="ts-text-right ts-pr-3" style="width: 104px;">
                  {{ totalAmountPaid(record) }}
                </div>
              </div>
            </div>
          </template>
        </a-table>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'

export default {
  name: 'receipt-detail',
  props: ['value', 'validation'],
  data() {
    return {
      loading: false,
      search: '',
      model: {},
      errors: new Errors(),
      checkedInvoice: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('wholesaleReceipt.date'),
          dataIndex: 'stock_out_date',
          width: '100px'
        },
        {
          title: this.$t('wholesaleReceipt.invoiceNo'),
          dataIndex: 'invoice_no',
          width: '130px'
        },
        {
          title: this.$t('wholesaleReceipt.refInvoiceNo'),
          dataIndex: 'reference_no',
          width: '120px'
        },
        {
          title: this.$t('wholesaleReceipt.saleName'),
          dataIndex: 'sale.employee_name_en',
          width: '120px'
        },
        {
          title: this.$t('wholesaleReceipt.nextPayment'),
          dataIndex: 'next_payment_date',
          width: '115px'
        },
        {
          title: this.$t('wholesaleReceipt.borrowingRef'),
          dataIndex: 'ref_sfo_id',
          width: '120px'
        },
        {
          title: this.$t('wholesaleReceipt.invoiceAmount'),
          dataIndex: 'amount_due',
          scopedSlots: { customRender: 'amount_due' },
          className: 'text-right',
          width: '125px'
        },
        {
          title: this.$t('wholesaleReceipt.amountDue'),
          scopedSlots: { customRender: 'amount_due_paid' },
          className: 'text-right',
          width: '110px'
        },
        {
          title: this.$t('wholesaleReceipt.amountPaid'),
          dataIndex: 'amount_paid',
          scopedSlots: { customRender: 'amount_paid' },
          width: '110px'
        }
      ]
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    }
    // payment_list () {
    //   if (this.model.payment_list) {
    //     this.model.payment_list = this.model.payment_list.filter(c => {
    //       return this.search == c.invoice_no.toLowerCase()
    //     })
    //   }
    // }
  },
  methods: {
    // handleSearch (value) {
    //   if (this.model.payment_list) {
    //     this.model.payment_list = this.model.payment_list.filter(c => {
    //       return this.search == c.invoice_no.toLowerCase()
    //     })
    //   }
    // },
    displayCurrency(record) {
      if (parseInt(record)) {
        return this.$defaultCurrencyWithCode(
          _.round(record, this.default_precision),
          this.default_precision
        )
      }
      return '$ ' + parseFloat(record).toFixed(this.default_precision)
    },
    totalInvoiceAmount(records) {
      let totalInvoiceAmount = _.sumBy(records, function(el) {
        return parseFloat(el.amount_due)
      })
      if (parseInt(totalInvoiceAmount)) {
        return this.$defaultCurrencyWithCode(
          _.round(totalInvoiceAmount, this.default_precision),
          this.default_precision
        )
      }
      return 0
    },

    totalAmountDue(records) {
      let totalAmountDue = _.sumBy(records, function(el) {
        return parseFloat(el.amount_due_paid, 2)
      })
      if (parseFloat(totalAmountDue, 2) > 0) {
        return this.$defaultCurrencyWithCode(
          parseFloat(totalAmountDue, this.default_precision),
          this.default_precision
        )
      }
      return '$ 0.00'
    },

    totalAmountPaid(records) {
      let totalAmountPaid = _.sumBy(records, function(el) {
        return parseFloat(el.amount_paid)
      })
      if (parseInt(totalAmountPaid)) {
        return this.$defaultCurrencyWithCode(
          _.round(totalAmountPaid, this.default_precision),
          this.default_precision
        )
      }
      return '$ 0.00'
    },

    displayCurrencyAmountDuePaid(record) {
      if (
        _.round(record.amount_due_paid, this.default_precision) > 0 ||
        _.round(record.amount_due, this.default_precision) ==
          _.round(record.amount_paid, this.default_precision)
      ) {
        if (_.round(record.amount_due_paid, this.default_precision) > 0) {
          return this.$defaultCurrencyWithCode(
            _.round(record.amount_due_paid, this.default_precision),
            this.default_precision
          )
        }
        return '$ 0.00'
      }
      return this.$defaultCurrencyWithCode(
        _.round(record.amount_due, this.default_precision),
        this.default_precision
      )
    },
    checkItem(value) {
      this.checkedInvoice = []
      if (!_.isEmpty(value)) {
        value.forEach(element => {
          this.checkedInvoice.push(element)
        })
      }
      this.calculationAmountPaid()
    },
    calculationAmountPaid() {
      let oldAmountPaid = this.model.amount_paid
      let invoiceListsCheck = this.model.payment_list
      this.model.payment_list = []
      this.model.invoice_amount = null

      invoiceListsCheck.forEach(e => {
        let amount_paid = 0
        let amount_due = 0
        let check = this.checkedInvoice.find(el => el == e.stock_out_id)
        if (check) {
          this.model.invoice_amount = parseFloat(
            this.model.invoice_amount + e.amount_due
          )

          let param = this.model.amount_paid - e.amount_due
          if (param > 0) {
            amount_paid = e.amount_due
            amount_due = 0
            this.model.amount_paid = param
          } else {
            if (this.model.amount_paid > 0) {
              amount_paid = this.model.amount_paid
              amount_due = e.amount_due - this.model.amount_paid
              this.model.amount_paid = 0
            } else {
              amount_paid = 0
              amount_due = e.amount_due
            }
          }
        }
        this.model.payment_list.push({
          amount_due: e.amount_due,
          customer: e.customer,
          customer_id: e.customer_id,
          invoice_no: e.invoice_no,
          next_payment_date: e.next_payment_date,
          stock_out_date: e.stock_out_date,
          stock_out_id: e.stock_out_id,
          seller_id: e.seller_id,
          sale: e.sale,
          ref_sfo_id: e.ref_sfo_id,
          reference_no: e.reference_no,
          amount_paid: _.round(amount_paid, this.default_precision),
          amount_due_paid: _.round(amount_due, this.default_precision)
        })
      })
      this.model.amount_paid = oldAmountPaid

      this.model.amount_due = _.round(
        this.model.invoice_amount - this.model.amount_paid,
        this.default_precision
      )
    },
    getInvoiceList() {
      if (this.model.customer_id) {
        this.loading = true
        this.$store
          .dispatch('wholesale/receipt/getInvoice', this.model.customer_id)
          .then(response => {
            this.model.payment_list = response.data.filter(
              el => el.amount_due > 0
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.model.payment_list = []
      }
    },
    getNextPaymentDate() {
      let check = this.model.payment_list.find(
        el => el.amount_due - el.amount_paid > 0
      )
      if (check) {
        this.model.next_payment_date = check.next_payment_date
      }
    }
  },
  watch: {
    'model.customer_id': debounce(function() {
      this.getInvoiceList()
    }, 500),
    'model.payment_list': debounce(function() {
      this.getNextPaymentDate()
    }, 500),
    search: debounce(function(search) {
      this.handleSearch(search)
    }, 500)
  }
}
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
.text-right {
  text-align: right;
}
.no-wrap {
  white-space: nowrap;
}
</style>
